module.exports = {
      id: "game-shop-usage",
      viewBox: "0 0 48.679 33.19",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#game-shop",
      toString: function () {
        return this.url;
      }
    }